import React, { useState } from 'react';
import { Select } from '@components/Select';
import { SimpleSelect } from '@components/SimpleSelect';
import { getNameFromList, getNameFromSubList } from './StoriesFilter.helpers';
import { StoriesFilter as StoriesFilterType, StoriesPage } from '@pages/Stories/Stories.types';
import { getFiltersFromURL, setURLfromFilters } from '@pages/Stories/Stories.helpers';

type StoriesFilterItems = Omit<StoriesFilterType, 'page'>;

const defaultFilters: StoriesFilterItems = {
  industry: 0,
  subIndustry: 0,
  country: 0,
};
interface StoriesFilterProps {
  i18n: Record<string, string>;
  storiesPageData: StoriesPage;
  onStoriesUpdate: (filters: StoriesFilterItems) => void;
}

export const StoriesFilter = ({ i18n, storiesPageData, onStoriesUpdate }: StoriesFilterProps) => {
  const [filters, setFilters] = useState<StoriesFilterItems>(getFiltersFromURL());
  const [resetCount, setResetCount] = useState(0);

  const subIndustriesList =
    storiesPageData.Industries.find((i) => +i.Id === filters.industry)?.SubIndustries || [];

  const setFilter = (newFilter: Partial<StoriesFilterItems>) => {
    setFilters({
      ...filters,
      ...newFilter,
    });
  };

  const onResetFilters = () => {
    setFilters(defaultFilters);
    setResetCount((resetCount) => resetCount + 1);
  };

  const onSaveFilters = () => {
    onStoriesUpdate(filters);
    setURLfromFilters(filters);
  };

  return (
    <div className='c-story-filter'>
      <div className='c-story-filter-filters'>
        <SimpleSelect
          title={getNameFromList(filters.industry, storiesPageData.Industries) || i18n.ShowAll}
          label={i18n.Industries}
          list={[
            {
              Name: i18n.ShowAll,
              Id: '',
            },
            ...storiesPageData.Industries,
          ]}
          name='Name'
          selectFunction={(value) => {
            setFilter({
              industry: +value?.Id || 0,
              subIndustry: 0,
            });
          }}
        />

        <SimpleSelect
          label={i18n.Subindustries}
          list={subIndustriesList}
          title={getNameFromList(filters.subIndustry, subIndustriesList) || i18n.ShowAll}
          disabled={!filters.industry}
          name='Name'
          selectFunction={(value) => setFilter({ subIndustry: +value?.Id || 0 })}
        />

        {storiesPageData.Countries && storiesPageData.Countries.length > 0 && (
          <Select
            backLabel={i18n.Back}
            label={i18n.Country}
            title={
              filters.country
                ? getNameFromSubList(filters.country, storiesPageData.Countries, 'Countries')
                : i18n.ShowAllRegions || i18n.ShowAll
            }
            defaultTitle={i18n.ShowAllRegions || i18n.ShowAll}
            list={storiesPageData.Countries}
            name='Name'
            sub='Countries'
            selectableTitle={true}
            selectFunction={(value) => setFilter({ country: +value?.Id || 0 })}
            resetTime={resetCount}
          />
        )}
      </div>
      <div className='c-story-filter-button'>
        <div className='c-story-filter-reset'>
          <button onClick={onResetFilters} className='c-button is-default is-small'>
            {i18n.ResetAll}
          </button>
        </div>

        <div className='c-story-filter-update'>
          <button onClick={onSaveFilters} className='c-button is-primary is-small'>
            {i18n.Update}
          </button>
        </div>
      </div>
    </div>
  );
};
